let enquirysubmitted = false;
export const globalState = { enquirysubmitted };
